import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { books } from "../data/books";
import { bookPath, booksPath } from "../lib/paths";

const T = {
  de: {
    rotulo: "Neuerscheinung",
    cta: "Zum Buch",
    all: "Alle Bücher",
    soon: "Erscheint",
  },
  es: {
    rotulo: "Novedad",
    cta: "Ver el libro",
    all: "Todos los libros",
    soon: "Publicación",
  },
};

export default function BookSpotlight({ language = "de" }) {
  const book = books[0];
  if (!book) return null;
  const t = T[language];
  const c = book[language];

  return (
    <section className="bg-hueso text-tinta py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-[minmax(200px,280px)_1fr] gap-10 md:gap-16 items-start">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
          >
            <Link to={bookPath(language, book.slug)} className="block group">
              <img
                src={book.coverSmall || book.cover}
                alt={book.title}
                width="280"
                height="433"
                loading="lazy"
                className="w-full max-w-[280px] shadow-[0_18px_50px_-18px_rgba(18,16,14,0.6)] group-hover:shadow-[0_22px_60px_-18px_rgba(18,16,14,0.75)] transition-shadow duration-300"
              />
            </Link>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ delay: 0.12, duration: 0.6 }}
          >
            <p className="rotulo text-loboOscuro mb-5">{t.rotulo}</p>

            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-titulo mb-3">
              {book.title}
            </h2>
            <p className="text-sombra mb-8">
              {book.author} · {c.genre}
            </p>

            <p className="font-serif italic text-xl sm:text-2xl text-loboOscuro mb-6">
              {c.tagline}
            </p>

            <p className="max-w-prosa text-tinta/85 mb-10">{c.blurb[0]}</p>

            <div className="flex flex-wrap items-center gap-6">
              <Link
                to={bookPath(language, book.slug)}
                className="rotulo bg-tinta text-hueso px-7 py-3.5 hover:bg-loboOscuro transition-colors"
              >
                {t.cta}
              </Link>
              <Link
                to={booksPath(language)}
                className="rotulo text-loboOscuro border-b border-loboOscuro/40 hover:border-loboOscuro pb-1 transition-colors"
              >
                {t.all}
              </Link>
              {!book.available && (
                <span className="rotulo text-sombra">
                  {t.soon} · {book.releaseLabel[language]}
                </span>
              )}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
